export enum MenuEnum{
    NOTIFICATION
}